/** A finger that strays no further than this is still a tap, not a drag. */
export const TAP_SLOP_PX = 10;

export interface TouchPoint {
  x: number;
  y: number;
}

export function isTouchDrag(start: TouchPoint, point: TouchPoint): boolean {
  return Math.hypot(point.x - start.x, point.y - start.y) > TAP_SLOP_PX;
}
